import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import { VueAuthenticate } from 'vue-authenticate'
import axios from 'axios';
import axiosclient from '../../utils/axiosclient';
import moment from 'moment-timezone'
Vue.use(Vuex)
Vue.use(VueAxios, axios)

const state = {
    

}

const getters = {}

const mutations = {
    
}

const actions = {
    fetchMyTimesheetEntries({commit}, payload) {
        commit("setLoading", true, { root: true });
        return axiosclient.get('/v1/timesheet-entries?start_date='+payload.startDate).then(res => {
            commit("setLoading", false, { root: true });
            let timesheets = res.data.data
            
            timesheets = timesheets.map(t => {
                
                t.start_date = moment.utc(t.start_date).tz(payload.timezone).format("DD-MM-YYYY HH:mm:ss")
                t.end_date = moment.utc(t.end_date).tz(payload.timezone).format("DD-MM-YYYY HH:mm:ss")

                return t
            })

            return Promise.resolve({data: timesheets})
        }).catch(err => {
            commit("setLoading", false, { root: true });
            return Promise.reject(err) 
        })
    },

    updateTimesheetEntry({ commit }, payload) {
        commit("setLoading", true, { root: true });
        return axiosclient
          .put("/v1/timesheet-entries/"+payload.timesheet_id, payload)
          .then(res => {
            commit("setLoading", false, { root: true });
            return Promise.resolve(res.data);
          })
          .catch(err => {
            console.log(err);
            commit("setLoading", false, { root: true });
            return Promise.reject(err);
          });
      },

      createTimesheetEntry({ commit }, payload) {
        commit("setLoading", true, { root: true });
        return axiosclient
          .post("/v1/timesheet-entries/manual", payload)
          .then(res => {
            commit("setLoading", false, { root: true });
            return Promise.resolve(res.data);
          })
          .catch(err => {
            console.log(err);
            commit("setLoading", false, { root: true });
            return Promise.reject(err);
          });
      },
      createLeaveEntry({ commit }, payload) {
        commit("setLoading", true, { root: true });
        return axiosclient
          .post("/v1/timesheet-entries/add/leave", payload)
          .then(res => {
            commit("setLoading", false, { root: true });
            return Promise.resolve(res.data);
          })
          .catch(err => {
            console.log(err);
            commit("setLoading", false, { root: true });
            return Promise.reject(err);
          });
      },




    
}

export default {
namespaced: true,
state,
getters,
mutations,
actions
}